import React from 'react';
import { CSSTransition } from 'react-transition-group';

import PageLayout from 'layouts/PageLayout';
import Form from 'scenes/Form/';
import Sidebar from 'scenes/Sidebar/';
import CtaBanner from 'scenes/Sidebar/components/CtaBanner';
import RelatedJobs from 'scenes/Sidebar/components/RelatedJobs';
import CandidateRegistrationForm from 'scenes/Form/components/CandidateRegistrationForm';
import { Event as GaEvent } from 'components/Tracking';
import { ANIMATION_TIMEOUT_APPEAR } from 'constants/animation.js';
import { ROUTE } from 'constants/route';

import ctaBackground from 'assets/images/cta_back_signup.jpg';
import './styles.css';

const CandidateAccountRegistration = props => {
  const { user, history, globalActions } = props;

  const handleAfterSaveForm = () => {
    GaEvent('screen_view', 'Candidate Registration Done', 'Candidate Registration Done')
    globalActions.loadUserState();
    history.replace(ROUTE.HOME);
  };

  return (
    <PageLayout
      pageClass="candidate-account-registration"
      pageTitle="Registration"
      mainContent={
        <CSSTransition
          in={true}
          appear={true}
          timeout={ANIMATION_TIMEOUT_APPEAR}
          classNames="fade"
        >
          <Form>
            <CandidateRegistrationForm
              onAfterSaveFormHandler={handleAfterSaveForm}
            />
          </Form>
        </CSSTransition>
      }
      sidebarContent={
        <CSSTransition
          in={true}
          appear={true}
          timeout={ANIMATION_TIMEOUT_APPEAR}
          classNames="fade"
        >
          <Sidebar>
            <CtaBanner
              blockHeight="150"
              blockBg={ctaBackground}
              blockText="Recruit Talent Through GoBuyside"
              blockFontSize="20"
            />
            <RelatedJobs user={user} history={history} />
          </Sidebar>
        </CSSTransition>
      }
    />
  );
};

export default CandidateAccountRegistration;
